<template lang="html">
<section class="aChat">
    <div v-if="popped">
        <div style="display: inline-block;" v-if="true">
            <div class="left"><span style="color:white; background-color: rgb(213, 32, 156)"><b>{{name1}}</b></span></div>
            <div class="middle"><b><span style="color:white; background-color: rgb(153, 0, 255)">{{name3}}</span></b></div>
            <div :class="(name3.length ? 'right2':'right')"><b><span style="color:white; background-color: rgb(53, 153, 255)">{{name2}}</span></b></div>
        </div>
        <basic-vue-chat :useInput="Boolean(false)" style="width:600px" class="Vlt-margin--top0 Vlt-margin--bottom1" :title="''" :new-message="message" :initial-feed="myChats" />
    </div>
</section>
</template>

<script lang="js">
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltCallout,
} from "@vonagevolta/vue";
import {
    FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';
import {
    $HTTPDEMO,
    requestHandler
} from '@/services/nidsService.js';

//import BasicVueChat from "basic-vue-chat";
import BasicVueChat from "@/components/chatter/src/components/basic-vue-chat/BasicVueChat";
import axios from 'axios';
export default {
    name: 'aChat',
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        newMessage: {
            type: Object,
            required: false
        }
    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-callout": VltCallout,
        "basic-vue-chat": BasicVueChat,
        //        "font-awesome-icon": FontAwesomeIcon,
    },
    watch: {
        newMessage: function (newVal) {
            console.log("New CHAT message: ", newVal)
            this.addMessage(newVal.id, newVal.event, newVal.message);
        }
    },
    data() {
        return {
            clr: 0,
            message: {},
            selected: '0',
            pusher: {},
            myChats: [],
            popped: true,
            messageList: [],
            newMessagesCount: 0,
            name1: "Speaker 1",
            name2: "Speaker 2",
            name3: "",
        }
    },
    methods: {
        isName(text) {
            let name = '';
            let test = text.match(/(?<=\y name is\s)(\w+)/);
            if (test?.length) {
                return test[0];
            }
            return;
        },
        addMessage(id, type, txt) {
            var author = "" + id;
            var color = "font-weight: bold";
            var cid = 0;
            let nname = this.isName(txt);
            if (type == "summary") {
                cid = 1;
                txt = "SUMMARY: " + txt;
                color = "color:white; background-color: darkgreen; font-weight: bold;margin-left: 100px";
                author = "";
            } else if (id < 10) {
                if (id == '0') {
                    if (nname) {
                        this.name1 = nname;
                    }
                    cid = 1;
                    author = "";
                    color = "color:white; background-color: rgb(213, 32, 156); font-weight: bold";
                } else if (id == '1') {
                    if (nname) {
                        this.name2 = nname;
                    }
                    cid = 0;
                    author = "";
                    color = "color:white; background-color: rgb(53, 153, 255); font-weight: bold";
                } else {
                    cid = 1;
                    if (nname) {
                        this.name3 = nname;
                    }
                    if (id > 2) {
                        txt = "(Spkr " + (id + 1) + "): " + txt;
                        color = "color:white; background-color: darkgreen; font-weight: bold;margin-left: 200px";
                    } else {
                        color = "color:white; background-color: rgb(153, 0, 255); font-weight: bold;margin-left: 200px";
                    }
                    author = "                   ";
                }
            }
            var date = new Date().toLocaleTimeString([], {
                hourCycle: 'h24'
            });
            this.message = {
                id: cid,
                author: author,
                contents: txt,
                date: date,
                msgstyle: color
            };
        },
    },
    created() {},
    beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
.left {
    float: left;
    padding-left: 20px;

}

.right {
    float: right;
    padding-left: 230px;
}

.right2 {
    float: right;
    padding-left: 180px;
}

.middle {
    float: left;
    padding-left: 200px;
}

.sel {
    padding: 5px;
    font-weight: bold;
}

//@import "@basic-vue-chat/assets/scss/modules/_all.scss";

$primary: red;
$secondary: blue;
$header-color: blue;
$window-height: 200px;
// above the following import you can override default values of variables like $primary
</style>
